export const getStyleChart = (chartEl) => {
  return chartEl.getStyles();
};
